import { render, staticRenderFns } from "./MerchantDetail.vue?vue&type=template&id=2d876d72&scoped=true"
import script from "./MerchantDetail.vue?vue&type=script&lang=js"
export * from "./MerchantDetail.vue?vue&type=script&lang=js"
import style0 from "./MerchantDetail.vue?vue&type=style&index=0&id=2d876d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d876d72",
  null
  
)

export default component.exports